import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import { fetchTicketCreatorsService } from '../../../components/Support/services/masterData';

import type { TicketCreator } from './support.types';
import { createInitialMasterState } from './helpers';

export const fetchTicketCreatorsAsyncThunk = createAsyncThunk(
  'supportTicketCreators/fetchTicketCreators',
  async (_, { rejectWithValue }) => {
    const { status, statusCode, data, message } =
      await fetchTicketCreatorsService();
    if (!status || statusCode !== 200 || !data)
      return rejectWithValue(message ?? 'Internal Server Error');
    return data;
  }
);

export const ticketCreatorsSlice = createSlice({
  name: 'supportTicketCreators',
  initialState: createInitialMasterState<TicketCreator>(),
  reducers: {
    clearError: state => {
      state.error = null;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchTicketCreatorsAsyncThunk.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        fetchTicketCreatorsAsyncThunk.fulfilled,
        (state, action: PayloadAction<TicketCreator[]>) => {
          state.loading = false;
          state.data = action.payload;
        }
      )
      .addCase(fetchTicketCreatorsAsyncThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const { clearError } = ticketCreatorsSlice.actions;
export default ticketCreatorsSlice.reducer;
